export const formatNumber = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return Number(value).toLocaleString();
};

export const formatDecimal = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

export const formatPercent = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return `${(value * 100).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
};

// Signed formatting for month-over-month deltas — always shows the sign so a
// gain and a loss are never distinguished by color alone.
export const formatSignedNumber = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${Number(value).toLocaleString()}`;
};

export const formatSignedPercent = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${(value * 100).toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
};

export const deltaTextClass = (value) => {
  if (value === null || value === undefined || Number.isNaN(value) || value === 0) return "text-muted-foreground";
  return value > 0 ? "text-green-600" : "text-red-600";
};

export const formatMetricValue = (value, type) => {
  if (type === "decimal") return formatDecimal(value);
  return formatNumber(value);
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return Number(value).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
};

// A plain date string ("2026-08-19") or Date-parseable value -> "Aug 19, 2026".
export const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" });
};

// A month-start date/string -> "Aug 2026", for months_active-style columns.
export const formatMonth = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", timeZone: "UTC" });
};
